import { render, staticRenderFns } from "./categoryDiscountTable.vue?vue&type=template&id=0ec87f44&"
import script from "./categoryDiscountTable.vue?vue&type=script&lang=js&"
export * from "./categoryDiscountTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports